module.exports = __webpack_public_path__ + "img/vegetable-garlic-190x100.58802d0d.jpg";